function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export class GraphQLClientError extends Error {
  constructor(error) {
    let {
      request,
      response,
      message,
      stack
    } = error;
    super(message);

    // E.g. when a 404 or 50x error happens, the HTML body of the response will be in `error` of `response`.
    _defineProperty(this, "response", void 0);
    _defineProperty(this, "request", void 0);
    _defineProperty(this, "errors", void 0);
    _defineProperty(this, "httpStatus", void 0);
    let {
      errors,
      error: errorMessage,
      status
    } = response;
    if (!errors && errorMessage) {
      errors = [{
        message: errorMessage,
        locations: [],
        path: [],
        extensions: {
          IS_PLAIN_ERROR: true
        }
      }];
    }
    this.errors = errors || [];
    this.response = response;
    this.request = request;
    this.httpStatus = status;
    this.stack = stack;
  }
  toJSON() {
    return this.errors;
  }
}
export default GraphQLClientError;